import React, { useState, useEffect } from 'react'
import Topbar from '../components/Layout/Topbar'
import { Sidebar } from '../components/Layout/Sidebar'
import { useParams } from 'react-router-dom'
import UserDetailsArea from '../CreateUser/UserDetailsArea'
import emailjs from "@emailjs/browser";
import { supabase, getUserProfile, updateUserProfile } from '../supabase.config'
const UserDetailsAdmin = () => {
    const { id } = useParams()
    const [profile, setProfile] = useState({})
    const [billAmount, setBillAmount] = useState(0)

    const mapUserRowToProfile = (row) => ({
      id: row?.id,
      name: row?.name,
      email: row?.email,
      contact: row?.contact,
      companyName: row?.company_name,
      gstNo: row?.gst_no,
      gstDocument: row?.gst_document,
      agreement: row?.agreement,
      otherDoc: row?.other_doc,
      insuranceType: row?.insurance_type,
      companyAddress: row?.company_address,
      role: row?.role,
      partnerType: row?.partner_type,
      walletBalance: row?.wallet_balance,
      service: row?.service,
      rateList: row?.rate_list,
      billAmount: row?.bill_amount ?? 0,
    })

    const fetchUser = async () => {
      const { data, error } = await getUserProfile(id)
      if (error) {
        console.error('Failed to fetch user profile:', error)
        return
      }
      const mapped = mapUserRowToProfile(data)
      setProfile(mapped)
      setBillAmount(mapped.billAmount || 0)
    }

    const updateBillAmount = async () => {
      const amt = Number(billAmount) || 0
      const { error } = await updateUserProfile(id, { bill_amount: amt })
      if (error) {
        console.error('Failed to update bill amount:', error)
        alert('Error updating bill amount')
        return
      }
      // Optimistically update local state
      setProfile((p) => ({ ...p, billAmount: amt }))
    }
   const sendBillDueEmail =  () =>{
    emailjs.init("dnrFfmJPSD_LmYGIf")
    const SERVICE_ID = "service_lm6wf94"
    const TEMPLATE_ID = "template_jtxt516"
    emailjs.send(SERVICE_ID, TEMPLATE_ID, {
    to_email:profile?.email,
    from_email:"grclogistics6@gmail.com",
    to_name:profile?.name,
    amount: profile?.billAmount
    }).then((result) => {
        alert("Email Sent")
    }).catch((err) => {
        alert("Error Occured:"+err.message)
    });
    
   }
   useEffect(() => {
    fetchUser()

    // Realtime updates for this user row
    const channel = supabase
      .channel('user-details-admin')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'users', filter: `id=eq.${id}` },
        (payload) => {
          const newRow = payload.new || payload.old
          if (newRow && (payload.eventType === 'UPDATE' || payload.eventType === 'INSERT')) {
            const mapped = mapUserRowToProfile(newRow)
            setProfile(mapped)
            setBillAmount(mapped.billAmount || 0)
          }
        }
      )
      .subscribe()

    return () => {
      try { supabase.removeChannel(channel) } catch {}
    }
   }, [id])
  return (
    <div className='bg-gray-100 flex '>
     <Sidebar />
    <div className='h-[100vh] overflow-y-scroll flex flex-1 flex-col' >
    <Topbar />
      
        <UserDetailsArea sendBillDueEmail={sendBillDueEmail} billAmount={billAmount} updateBillAmount={updateBillAmount} setBillAmount={setBillAmount} profile={profile} />
    </div>
    </div>
  )
}

export default UserDetailsAdmin
